export default () => {
    const mapComponent = document.querySelector("*[map-component]");
    if (mapComponent == null)
        return;
    import(/*webpackChunkName: 'counter animation'*/ "../classes/counterAnimationClass")
        .then(({ default: counterAnimation }) => {
        new counterAnimation(mapComponent);
    })
        .catch(() => "An Error has occurred with 404 animation");
};
